import OnboardingBeaconWrapper from './onboardingBeacons/OnboardingBeaconWrapper';
import { useShouldShowOnboardingBeacons } from './onboardingBeacons/hooks/useShouldShowOnboardingBeacons';
import { jsx as _jsx } from "react/jsx-runtime";
const OnboardingPatternWrapper = ({
  objectType
}) => {
  const shouldShowOnboardingBeacons = useShouldShowOnboardingBeacons(objectType);
  if (!shouldShowOnboardingBeacons) {
    return null;
  }
  return /*#__PURE__*/_jsx(OnboardingBeaconWrapper, {});
};
export default OnboardingPatternWrapper;